<h1 mat-dialog-title>DELETE CATEGORY</h1>
<div mat-dialog-content>
  <p>You cannot undo this action. Would you continue?</p>
</div>
<div mat-dialog-actions class="float-right">
  <button mat-button (click)="modalRemoveCategoryCancel()">CANCEL</button>
  <button mat-button (click)="removeCategory(category)" cdkFocusInitial>YES</button>
</div>